@if (pageSize$ | async; as currentPageSize) {
	<section
		id="plp-srlp-top-pagination"
		class="top-pagination_container hmf-display-flex hmf-mr-xs hmf-mr-lg-s hmf-py-lg-xxs hmf-subheader-m"
	>
		<div class="top-pagination-desktop hmf-display-none hmf-display-lg-block">
			<span class="hmf-mr-s">View:</span>
			@for (pageSize of pageSizeOptions; track trackByFn($index, pageSize)) {
				<button
					class="top-pagination_number hmf-mr-s"
					[ngClass]="{'selected hmf-subheader-bold-m' : pageSize === currentPageSize}"
					(click)="pageSizeClickEvent(pageSize, currentPageSize)"
				>
					{{pageSize}}
				</button>
			}
		</div>

		<div class="top-pagination-product-number">
			<span class="hmf-mr-xs">|</span>
			{{totalCount$ | async}} Products
		</div>
	</section>

}
